module.exports = __webpack_public_path__ + "img/B13a.1b9bc4aa.svg";